export default function Stats() {
  const stats = [
    { value: '5000+', label: '服务企业客户' },
    { value: '98%', label: '客户满意度' },
    { value: '10年+', label: '行业经验' },
    { value: '20000+', label: '起草文件数' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-500 font-heading mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}